import {
	useStaticDataGridModel,
	UseStaticDataGridModelParams,
	UseStaticDataGridModelReturn,
} from "src/components/common/dataGrid/gridModel/useStaticDataGridModel";
import React from "react";

export interface StaticDataGridModelProps<TRow extends object> extends UseStaticDataGridModelParams<TRow> {
	render: (props: UseStaticDataGridModelReturn<TRow>) => React.ReactNode;
}

export const StaticDataGridModel = <TRow extends object>({ render, ...other }: StaticDataGridModelProps<TRow>) => {
	const useStaticDataGridModelReturn = useStaticDataGridModel({
		...other,
	});

	return render(useStaticDataGridModelReturn);
};
